import { CRMAPIBase } from '@api/crmApiBase';
import { ScheduleExceptionSuggestPeriodsResp } from '@api/responseModels/worker/schedule/scheduleExceprionSuggestPeriods';
import { ScheduleExceptionListResp } from '@api/responseModels/worker/schedule/scheduleExceptionListResponse';
import { ScheduleExceptionResp } from '@api/responseModels/worker/schedule/scheduleExceptionResponse';
import { TScheduleException } from '@components/schedule/common/types';

class ScheduleExceptionGroup extends CRMAPIBase {
    async saveScheduleException(exception: TScheduleException) {
        const result = await this.post<ScheduleExceptionResp>('/schedule-exceptions', {
            crm_id: exception.crm_id,
            id: exception.id,
            type_id: exception.type.id,
            duration: exception.duration,
            start_date: exception.start_date,
            start_time: exception.start_time,
            //end_date: exception.end_date,
            //end_time: exception.end_time,
            status_id: exception.status.id,
            worker_positions: exception.worker_positions.map((wpi) =>
                typeof wpi == 'number' ? wpi : wpi.id
            ),
            description: exception.description,
        });
        return result;
    }

    async getScheduleException(crm_id: number, id: number) {
        const result = await this.get<ScheduleExceptionResp>(`/schedule-exceptions/${id}`, {
            crm_id,
        });
        return result;
    }

    async getScheduleExceptionList(crm_id: number, filters?: { worker_position?: number }) {
        const result = await this.get<ScheduleExceptionListResp>(
            '/schedule-exceptions',
            filters?.worker_position == null ? { crm_id } : { crm_id, filters: filters }
        );
        return result;
    }

    async updateScheduleException(exception: TScheduleException) {
        const result = await this.put<ScheduleExceptionResp>(
            `/schedule-exceptions/${exception.id}`,
            {
                crm_id: exception.crm_id,
                id: exception.id,
                type_id: exception.type.id,
                duration: exception.duration,
                start_date: exception.start_date,
                start_time: exception.start_time,
                //end_date: exception.end_date,
                //end_time: exception.end_time,
                status_id: exception.status.id,
                worker_positions: exception.worker_positions.map((wpi) =>
                    typeof wpi == 'number' ? wpi : wpi.id
                ),
                description: exception.description,
            }
        );
        return result;
    }

    async removeScheduleException(crm_id: number, id: number) {
        const result = await this.delete<ScheduleExceptionResp>(`/schedule-exceptions/${id}`, {
            crm_id,
        });
        return result;
    }

    async restoreScheduleException(crm_id: number, id: number) {
        const result = await this.post<ScheduleExceptionResp>(
            `/schedule-exceptions/${id}/restore`,
            {
                crm_id,
            }
        );
        return result;
    }
    async getScheduleExceptionSuggestPeriods(params: {
        duration: number;
        start_date: string;
        start_time: string;
        worker_positions: Array<number>;
    }) {
        const result = await this.post<ScheduleExceptionSuggestPeriodsResp>(
            `/schedule-exceptions/suggestPeriods`,
            params
        );
        return result;
    }

    async getScheduleExceptionCheckEventOverlap(params: {
        crm_id: Array<number>;
        start_date: string;
        start_time: string;
        duration: number;
    }) {
        const result = await this.post<ScheduleExceptionSuggestPeriodsResp>(
            `/schedule-exceptions/check-event-overlap`,
            params
        );
        return result;
    }
}

export { ScheduleExceptionGroup };
